<template>
  <div>
    <div>
      <div
        class="head-topbar lite-page-top linebottom sticky"
        style="background: rgb(255, 255, 255);"
      >
        <div class="topbar-left" @click="goto('/jnt/center/setting')">
          <i class="icon-arrow-left"></i>
        </div>
        <div class="topbar-main"><h4>更改手机号</h4></div>
        <div class="topbar-right"></div>
      </div>
      <div class="setting-mobile-box">
        <div class="mobile-title">当前手机号：15000507686</div>
        <div class="mobile-text">更换后，下次登录请使用新手机号登录</div>
        <!-- <div class="mobile-title">当前手机号：还未绑定手机号</div>
        <div class="mobile-text">更换后，下次登录请使用新手机号登录</div> -->
      </div>
      <div class="setting_mobile">
        <div class="mobile_input-box">
          <div class="mobile_input-title">手机号码</div>
          <div class="mobile_input-content">
            <input type="number" placeholder="请输入手机号码" />
          </div>
        </div>
        <div class="mobile_input-box">
          <div class="mobile_input-title">验证码</div>
          <div class="mobile_input-content"><input type="number" placeholder="请输入验证码" /></div>
          <div class="mobile_code"><span>获取验证码</span></div>
        </div>
        <div class="mobile_submit"><button class="mobile_submit-btn">完成</button></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bind',
  data() {
    return {}
  },
  methods: {
    goto(str) {
      this.$router.push({ path: str })
    },
  },
  created() {},
  watch: {},
}
</script>

<style>
.setting_mobile {
  padding: 15px;
}

.setting_mobile .mobile_page-top {
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  margin-bottom: 20px;
}
.setting_mobile .mobile_page-title {
  font-size: 1.5rem;
  color: #000;
  line-height: 30px;
  font-weight: 700;
}
.setting_mobile .mobile_page-title-s {
  color: #999;
  font-size: 1rem;
  margin-top: 5px;
}
.mobile_input-box {
  height: 50px;
  font-size: 1.3rem;
  display: -webkit-flex;
  display: flex;
  background: #fff;
  position: relative;
  -webkit-align-items: center;
  align-items: center;
  line-height: 22px;
  margin-bottom: 10px;
  padding-left: 15px;
  border-radius: 10px;
  padding-right: 15px;
}
.mobile_input-title {
  color: #666;
  min-width: 4em;
  padding-right: 16px;
}
.mobile_input-content {
  -webkit-flex: 1 1;
  flex: 1 1;
}
.mobile_input-content input {
  width: 100%;
  background: 0 0;
  border: none;
  outline: 0;
  -webkit-appearance: none;
  line-height: 22px;
}
input,
textarea {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
button,
input,
select,
textarea {
  -webkit-appearance: none;
}
.mobile_code span {
  display: block;
  padding: 4px 0;
  border-radius: 15px;
  font-size: 1.2rem;
  color: #15a892;
  line-height: 22px;
}
.mobile_submit {
  padding: 32px 0 15px;
}
.mobile_submit-btn {
  width: 100%;
  background: #15a892;
  border-radius: 20px;
  color: #fff;
  font-size: 1.4rem;
  line-height: 3.6rem;
  border: none;
  outline: 0;
  -webkit-appearance: none;
  cursor: pointer;
}
.weui-cells {
  margin-top: 1.17647059em;
  background-color: #fff;
  line-height: 1.41176471;
  font-size: 17px;
  overflow: hidden;
  position: relative;
}
.weui-cell {
  padding: 15px;
  position: relative;
  display: flex;
  align-items: center;
}
.weui-cell__bd {
  flex: 1;
}
.text-center {
  text-align: center;
}
.weui-cells:after,
.weui-cells:before {
  content: ' ';
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  color: #e5e5e5;
}
.weui-cells:before {
  top: 0;
  border-top: 1px solid #e5e5e5;
  transform-origin: 0 0;
  transform: scaleY(0.5);
}
.weui-cells:after {
  bottom: 0;
  transform-origin: 0 100%;
  transform: scaleY(0.5);
}
.weui-cells:after,
.weui-cells:before {
  content: ' ';
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  color: #e5e5e5;
}
.head-topbar.sticky {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
}
.head-topbar {
  display: flex;
  align-items: center;
  height: 3.8rem;
  background: #fff;
  position: fixed;
  width: 100%;
  z-index: 1;
}
.dashedlinebottom,
.dashedlinetop,
.linebottom,
.lineright,
.linetop {
  position: relative;
  -webkit-box-sizing: border-box;
  padding: 0;
}
.head-topbar .topbar-left {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.73333vw;
  position: absolute;
  left: 0.265rem;
  height: 100%;
  z-index: 10;
}

.head-topbar .topbar-left .icon-arrow-left {
  background: url(../../../assets/jnt/left1.png) no-repeat;
  background-size: 100%;
  display: inline-block;
  height: 1.363rem;
  width: 0.818rem;
}
.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
.head-topbar .topbar-main {
  flex: 1;
  color: #333;
  font-size: 1.454rem;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: 400;
}
.head-topbar .topbar-right {
  padding-right: 1rem;
  position: absolute;
  right: 0.265rem;
  font-size: 1.272rem;
}
.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
.setting-mobile-box {
  width: 100%;
  margin: 0 auto;
  margin-top: 3.27rem;
  text-align: center;
}

.setting-mobile-box .mobile-title {
  font-size: 1.64rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333;
  line-height: 1.64rem;
  margin-bottom: 1.09rem;
}

.setting-mobile-box .mobile-text {
  font-size: 1.18rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999;
  line-height: 1.18rem;
}
</style>
